.transcribe {
    position: absolute;
    bottom: 8px;
    right: 8px;
    color: white;
    fill: white;
}
